module.exports = __webpack_public_path__ + "assets/img/6fc0-be.svg";